import styled from 'styled-components';

export const Navigation = styled.nav`
  position: sticky;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  top: 0;
  height: 72px;
  background-color: #fff;
  box-shadow: 0 0 20px #00000040;
`;
